// Get the Mapbox access token from environment variables
export const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

// Validate that the token exists
if (!MAPBOX_ACCESS_TOKEN) {
  console.error('Mapbox access token is missing. Please add REACT_APP_MAPBOX_ACCESS_TOKEN to your .env file');
} 